 <div class="row wide-bg d-flex justify-content-center inner-wrapper" [style.height]="'500px'" [style.backgroundRepeat]="'no-repeat'" [style.backgroundPosition]="'center'"
      [style.background-image]="this.bgImageUrl ? 'url(' + this.bgImageUrl + ')' : ''">
   <div class="col-lg-8" style="width: 400px;flex: none; padding: 0">
     <div class="m-content form-block">
       <div class="row">
         <div class="col-sm-12 login-box">
           <div>
             <div>
               <h1 class="login-page-title accent-text ">
                 {{'WELCOME' | dictionary}}
               </h1>
             </div>
             <div class="pt-0 pb-0" style="padding:0;">
               <form (submit)="login()">
                 <div class="m-portlet__body">
                   <div class="form-group pb-3" style="height: 55px;">

                     <input [(ngModel)]="userProfile.UserId"
                            class="form-control home-login-input-text" name="username" id="username" maxlength="50"
                            aria-describedby="emailHelp" placeholder="{{'USERNAME' | dictionary}}"/>
                     <span class="float-right text-color-deep-heading">
                                             <a style="font-weight: 600;" href="javascript:void(0);" tabindex="-1"
                                                class="link-2"
                                                (click)="tryToNavigate('/forgot-username')">{{'FORGOT_USERNAME' | dictionary}}</a>
                                         </span>
                   </div>
                   <div class="form-group" style="height: 50px;">
                     <input [(ngModel)]="userProfile.Password" [type]="showPassword ? 'text' : 'password'"
                            class="form-control  home-login-input-text" name="password" id="password"
                            placeholder="{{'PASSWORD' | dictionary}}"/>
                     <i class="fas icon cursor-pointer eye-bg"
                        [pTooltip]="(!showPassword ? 'SHOW_PASSWORD' : 'HIDE_PASSWORD' ) | dictionary"
                        [ngClass]=" {'fa-eye' : !showPassword, 'fa-eye-slash' : showPassword }"
                        (click)="showPassword = !showPassword"></i>
                     <span class="float-right text-color-deep-heading">
                                             <a style="font-weight: 600;" href="javascript:void(0);" tabindex="-1"
                                                class="link-2"
                                                (click)="tryToNavigate('/forgot-password')">{{'FORGOT_PASSWORD' | dictionary}}</a>
                                         </span>
                   </div>
                   <div class="form-group text-center" style="margin: 0;">
                     <button type="submit"
                             class="button-1">
                       {{'SIGN_IN' | dictionary}}
                     </button>&nbsp;&nbsp;
                   </div>
                   <div class="form-group home-box-small-text ">
                     <span class="form-text text-center tiny-note-color">
                       {{'NOT_YET_REGISTERED' |dictionary}}
                       <a style="font-weight: 600; text-decoration: underline; background-color: #FFFF00" href="javascript:void(0);" class="link-2"
                          (click)="tryToNavigate('/registration-investor')">{{'REGISTER' | dictionary}}</a><br>
                       {{'IF_YOU_ADVISOR' |dictionary}}
                       <a style="font-weight: 600; text-decoration: underline; background-color: #FFFF00" href="javascript:void(0);" class="link-2"
                          (click)="tryToNavigate('/registration-rep')"
                       >{{'REGISTER' | dictionary}}</a>
                       <br *ngIf="showProxyLink">
                       <br *ngIf="showProxyLink">
                       <span style="font-weight: 600; font-size: larger" *ngIf="showProxyLink">{{'CLICK_HERE' | dictionary}} <a [routerLink]="['/proxy']"
                         style="font-weight: 600; font-size: larger; text-decoration: underline; background-color: #FFFF00" class="link-2"
                       >{{'PROXY_VOTING' | dictionary}}</a></span>
                     </span>
                   </div>
                 </div>
               </form>
             </div>
           </div>
         </div>
       </div>
     </div>
   </div>
   <app-pop-up-dialog [Message]="alertMessage" [Display]="display" (DisplayBack)="onConfirm($event)">
   </app-pop-up-dialog>
 </div>
 <div class="footer-wrapper">
   <img class="footer" *ngIf="footerImage" [src]="footerImage"  (error)="handleMissingImage($event)"/>
   <div class="build-version" *ngIf="buildVersion">REV: {{buildVersion}}</div>
 </div>

